import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=2f9340a0&scoped=true&"
import script from "./NotesModal.vue?vue&type=script&lang=js&"
export * from "./NotesModal.vue?vue&type=script&lang=js&"
import style0 from "./NotesModal.vue?vue&type=style&index=0&id=2f9340a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9340a0",
  null
  
)

export default component.exports